// extracted by mini-css-extract-plugin
export default {"box":"SimArg_box__eoFxq","label":"SimArg_label__03q9d"};